{
    "v": "5.9.6",
    "fr": 30,
    "ip": 0,
    "op": 26,
    "w": 62,
    "h": 62,
    "nm": "Small heart_DEactivate_dark 02",
    "ddd": 0,
    "assets": [],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Layer 2",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [0.5],
                  "y": [1]
                },
                "o": {
                  "x": [0.167],
                  "y": [0.167]
                },
                "t": 10,
                "s": [100]
              },
              {
                "t": 20,
                "s": [0]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [0.5],
                  "y": [1]
                },
                "o": {
                  "x": [0.167],
                  "y": [0.1]
                },
                "t": 0,
                "s": [0]
              },
              {
                "t": 15,
                "s": [25]
              }
            ],
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.5,
                  "y": 1
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 0,
                "s": [34.301, 31.006, 0],
                "to": [1.667, 0.832, 0],
                "ti": [-1.667, -0.832, 0]
              },
              {
                "t": 15,
                "s": [44.301, 36, 0]
              }
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [0, 0, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [2.729, 0],
                      [0.928, -1.327],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.38, 0.226],
                      [-1.161, 0.981],
                      [0, 2.781]
                    ],
                    "o": [
                      [-1.608, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.237, -0.126],
                      [0.77, -0.458],
                      [2.944, -2.489],
                      [0, -2.75]
                    ],
                    "v": [
                      [0.749, -8.005],
                      [-3.301, -5.886],
                      [-5.699, -2.9],
                      [-1.795, 0.613],
                      [-4.98, 4.003],
                      [-3.301, 8.005],
                      [-2.833, 7.757],
                      [-1.894, 7.23],
                      [1.199, 5.038],
                      [5.699, -3.019]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [1, 1, 1, 1],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 26,
        "st": 0,
        "ct": 1,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Layer 1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [0.5],
                  "y": [1]
                },
                "o": {
                  "x": [0.167],
                  "y": [0.167]
                },
                "t": 10,
                "s": [100]
              },
              {
                "t": 20,
                "s": [0]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [0.5],
                  "y": [1]
                },
                "o": {
                  "x": [0.167],
                  "y": [0.1]
                },
                "t": 0,
                "s": [0]
              },
              {
                "t": 15,
                "s": [-25]
              }
            ],
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.5,
                  "y": 1
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 0,
                "s": [27.253, 31.006, 0],
                "to": [-1.667, 0.832, 0],
                "ti": [1.667, -0.832, 0]
              },
              {
                "t": 15,
                "s": [17.253, 36, 0]
              }
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [0, 0, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.609, 0],
                      [0, -2.75],
                      [-2.944, -2.489],
                      [-1.123, -0.668],
                      [-0.237, -0.126],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [-0.927, -1.327],
                      [-2.729, 0],
                      [0, 2.781],
                      [0.931, 0.787],
                      [0.379, 0.226],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [5.253, 0.613],
                      [1.349, -2.9],
                      [3.747, -5.886],
                      [-0.303, -8.005],
                      [-5.253, -3.019],
                      [-0.753, 5.038],
                      [2.341, 7.23],
                      [3.279, 7.757],
                      [3.747, 8.005],
                      [2.068, 4.003]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [1, 1, 1, 1],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 26,
        "st": 0,
        "ct": 1,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Big heart",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [31, 30.952, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [0, 0, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [-0.718, -1.027],
                      [0, 0],
                      [0, 0],
                      [-1.332, 0],
                      [0, -2.209],
                      [2.182, -1.846],
                      [0.811, -0.482],
                      [0.227, -0.12],
                      [0.362, 0.215],
                      [1.072, 0.906],
                      [0, 2.949],
                      [-2.174, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0.718, -1.027],
                      [2.175, 0],
                      [0, 2.949],
                      [-1.072, 0.906],
                      [-0.362, 0.215],
                      [-0.227, -0.12],
                      [-0.811, -0.482],
                      [-2.182, -1.846],
                      [0, -2.209],
                      [1.332, 0]
                    ],
                    "v": [
                      [-0.82, -5.247],
                      [0, -4.075],
                      [0.82, -5.247],
                      [4.05, -6.94],
                      [8, -2.953],
                      [3.854, 4.34],
                      [0.896, 6.436],
                      [0, 6.94],
                      [-0.896, 6.436],
                      [-3.854, 4.34],
                      [-8, -2.953],
                      [-4.05, -6.94]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [1, 1, 1, 1],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 2,
                  "ix": 5
                },
                "lc": 1,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [1, 1, 1, 1],
                  "ix": 4
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [0.833],
                        "y": [0.833]
                      },
                      "o": {
                        "x": [0.167],
                        "y": [0.167]
                      },
                      "t": 0,
                      "s": [100]
                    },
                    {
                      "t": 1,
                      "s": [0]
                    }
                  ],
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0, 0],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 26,
        "st": 0,
        "ct": 1,
        "bm": 0
      }
    ],
    "markers": []
  }
  